import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { globalLoader, MEDIA } from '@/helpers/variables';
import { PRODUCTS_ORDER_KEY } from '@/helpers';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import ProductsFilters from '@/components/products/ProductsFilter/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'Selection',
  mixins: [dynamicHead],
  components: {
    ProductsFilters,
    ProductsBlock,
    BreadcrumbsSimple,
    Pagination
  },
  data() {
    return {
      MEDIA,
      selectionData: null,
      selectionPage: 1,
      selectionProducts: [],
      selectionProductsMeta: null,
      isSelectionProductsLoading: false
    };
  },
  created() {
    globalLoader(true);
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      appSize: 'app/size',
      filters: 'filters/filters'
    }),
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.selectionProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.selectionProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getFilters: 'filters/GET_FILTERS',
      getSelectionProducts: 'selection/GET_SELECTION_PRODUCTS',
      getPage: 'staticPages/GET_PAGE'
    }),
    async _getProducts() {
      this.isSelectionProductsLoading = true;
      let { orderby, filters } = this.$route.query;
      let { page } = this.$route.params;

      let params = {
        page: page ? Number(page) : 1,
        sort_filter_type: orderby ? orderby : PRODUCTS_ORDER_KEY.BESTSELLERS
      };

      if (filters) {
        let categories = filters.split('|').reduce((acc, categoryString) => {
          let idsArray = categoryString.slice(categoryString.indexOf('[') + 1, categoryString.indexOf(']')).split('-');
          return [...acc, ...idsArray];
        }, []);
        params = { ...params, categories: categories.join(',') };
      }

      return this.getSelectionProducts(params)
        .then((result) => {
          this.selectionProducts = result.data;
          this.selectionProductsMeta = result.meta;
        })
        .finally(() => {
          this.isSelectionProductsLoading = false;
        });
    },

    async _loadContent() {
      let promiseCollection = [];

      promiseCollection.push(this.getFilters());
      promiseCollection.push(this._getProducts());
      promiseCollection.push(
        this.getPage('podbor-kosmetiki').then((data) => {
          this.selectionData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection).then();

      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.selectionData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
